import React, { useState } from 'react';
import '../../App.css';


const CopyURL = props => {
	
	const { url } = props
	const [copied, setIsCopied] = useState(false)
	
	async function copyTextToClipboard(text) {
		console.log(navigator)
		if ('clipboard' in navigator) {
		  return await navigator.clipboard.writeText(text);
		} else {
		  return document.execCommand('copy', true, text);
		}
	}
	
	const handleCopyClick = () => {
		// Asynchronously call copyTextToClipboard
		copyTextToClipboard(url)
		  .then(() => {
			// If successful, update the isCopied state value
			setIsCopied(true);
			document.getElementById("url-loja-input").select();
			setTimeout(() => {
			  setIsCopied(false);
			}, 1500);
		  })
		  .catch((err) => {
			console.log(err);
		  });
	}
	
	return (
	
		<div id="url-loja" className="entrance-animation">
			<input id="url-loja-input" type="text" className="form-control shadow-none" value={url + "CÓDIGO DE RASTREIO AQUI"} />
			<button className="btn btn-sm btn-success shadow-none" onClick={handleCopyClick}>{copied ? "copiado" : "copiar"}</button>
		</div>

	)
}
	

export default CopyURL;
